import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from '../View';
import Text from '../Text';
import Checkbox from '../Checkbox';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const Container = style(View, styles.container);
const AgreeCheck = style(Checkbox, styles.agreeCheck);
const AgreeTermsMessage = style(Text, styles.agreeTermsMessage);
const SMessage = style(Text, styles.message);

class AgreeTerms extends PureComponent {
  constructor(props) {
    super(props);
    const { checked } = props;
    this.state = { checked };
  }

  handleOnChange = (name, checked) => {
    const { onChange } = this.props;
    this.setState({ checked });
    onChange && onChange(checked);
  };

  render() {
    const { children, error, message } = this.props;
    return (
      <Container>
        <AgreeCheck
          name="agreeCheck"
          onChange={this.handleOnChange}
          error={error}
        >
          <AgreeTermsMessage>{children}</AgreeTermsMessage>
        </AgreeCheck>
        <Message message={message} error={error} />
      </Container>
    );
  }
}

const Message = ({ message, error }) =>
  message ? (
    <SMessage error={error} size="small">
      {message}
    </SMessage>
  ) : null;

AgreeTerms.propTypes = {
  children: PropTypes.any.isRequired,
  width: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  message: PropTypes.string
};

AgreeTerms.defaultProps = {
  error: false,
  checked: false,
  width: '100%'
};

export default AgreeTerms;
